import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询会员信息
export const queryMembers: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMembers', { ...state.members, loading: true });
    const { list, total, pageNum, pageSize } = await $http.post('/v1/data/system/org/financepagelist', payload);
    commit('setMembers', { data: list, total, pageNum, pageSize });
  } catch (e) {
    commit('setMembers', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 查询会员服务状态（只保留 '账号待续费', '服务待续费', '正常', '已锁定'）
export const queryServiceStates: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setServiceStates', { ...state.serviceStates, loading: true });
    const res: any[] = await $http.get('common/chooseoptions/ServiceState');
    const before = res.filter((item) => ['5', '6'].indexOf(item.optionKey) !== -1);
    const after = res.filter((item) => ['4', '7'].indexOf(item.optionKey) !== -1);
    commit('setServiceStates', { data: [...before, ...after] });
  } catch (e) {
    commit('setServiceStates', { data: [] });
  }
};

// 查询企业是否有 '设置为品牌拥有者' 的品牌
export const checkOwnerBrand: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const params = { owner: true, pageNum: 1, pageSize: 1, orgId: payload };
    commit('setHasOwnerBrand', null);
    // const res: IPageData = await $http.post('baseinfo/organizations/brand/detail', params);
    const res: IPageData = await $http.post('/v1/system/org/authbrands', params);
    commit('setHasOwnerBrand', !!res.total);
  } catch (e) {
    commit('setHasOwnerBrand', null);
  }
};
